const imagesCarousel = {
  backgroundColor: ({ theme }) => theme.colors.firefly,
}

export default imagesCarousel
